/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileCanvas32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            d="M9 3h9.585a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26a3 3 0 01-3 3H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            fill={vars.bdlOrange}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 15.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm3.729 4.521c.125-.016.44-.059.912.059l.09.022c.674.164 2.394.583 4.48 2.218.196.167.697.602.78.675.038.034.214.211.411.41.24.242.51.515.6.598V26a65.511 65.511 0 01-1.164-1.172c-.521-.541-.876-.87-1.345-1.3-.469-.43-1.733-1.361-2.488-1.675-.756-.313-1.08-.444-1.398-.49l.007.021a1.28 1.28 0 00.068.172c.016.034.028.06.039.104l.238.524.031.067.009.02.006.012.01.026.183.422c.266.613.465 1.108.594 1.473.177.502.27.925.153 1.285-.116.36-.398.508-.754.508-.537 0-1.303-.421-1.543-.567l-.086-.052a7.211 7.211 0 01-.621-.413c-.327-.234-.444-.362-.53-.455a2.335 2.335 0 00-.045-.049c-.094-.097-.319-.333-.359-.657-.023-.183.001-.398.107-.55.062-.088.16-.215.44-.25a.649.649 0 01.436.133c.051.036.151.137.27.255a6.17 6.17 0 00.608.555c.203.166.445.364.603.425-.032-.072-.09-.195-.147-.318v-.001a18.603 18.603 0 01-.137-.297 11.247 11.247 0 00-.194-.41c-.333-.684-.663-1.381-.807-1.814l-.024-.073c-.13-.387-.205-.612-.129-.884.052-.185.111-.32.337-.438.09-.047.23-.098.348-.113l.01-.002zm.71-6.778l2.483 3.974a.511.511 0 01-.44.783h-4.966a.515.515 0 01-.44-.783l2.484-3.974a.519.519 0 01.878 0zm-9.44 7.579c0-.454.368-.822.822-.822h3.356c.454 0 .822.368.822.822v3.356a.822.822 0 01-.822.822h-3.356a.822.822 0 01-.822-.822v-3.356z"
            fill="#fff"
        />
        <path
            opacity={0.5}
            d="M19.285 3.286l6.421 6.421a1 1 0 01.204.293h-4.911a2 2 0 01-1.995-1.85L19 8V3.09a1 1 0 01.286.196z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default FileCanvas32;
